// todo harmoniser les constantes
import { applicationCodes } from 'src/environments/application-codes';

export const constants = {
    codeVersionLogiciel: 'VUP',
    pourcentageTravailPleinTemps: 100,
    maxLengthComment: 8000,
    queryParamNames: {
        beneficiaryIdQueryParamKey: 'beneficiaryId',
        invoiceTypeQueryParamKey: 'type'
    },
    fieldsTypesCodes: {
        BOO: 'BOO',
        TXT: 'TXT',
        NUM: 'NUM',
        DAT: 'DAT',
        LST: 'LST',
    },
    facture: {
        statut: {
            SOLDE: 'SLD',
            PARTIELLEMENT_SOLDE: 'PSO',
            NON_SOLDE: 'NSO'
        }
    },
    ecriture: {
        FACTURE_CLIENT: 'FC',
        REGLEMENT_CLIENT: 'RC',
        FACTURE_FOUR: 'FF',
        REGLEMENT_FOUR: 'RF',
        ACOMPTE_FOUR: 'ACF',
        MANUELLE: 'MAN',
        REMISE_EN_BNQ: 'RBQ',
        ACOMPTE_CLIENT: 'ACC',
        AVOIR_CLIENT: 'AC',
        AVOIR_FOUR: 'AF',
        REMB_CLIENT: 'RBC',
        REMB_FOUR: 'RBF',
        REJET_RGL_CLIENT: 'RRC',
        PERTE_ET_PROFIT: 'PPA',
        ALIM_COMPTE_COURANT: 'ALF',
        ALIM_PMV: 'ALC',
        ANNUL_REMISE_EN_BNQ: 'ARB',
        ABOND_PMV: 'ABN',
        REPRISE_ECR_V1: 'RV1',
        SOLDER_PMV: 'SPM',
        CLOTURE_COMPTABLE: 'CLO',
        IMPUT_ACOMPTE_CLIENT: 'IAC',
        IMPUT_ACOMPTE_FOURNISSEUR: 'IAF',
        REMISE_CAISSE_CENTRALE: 'RCC',
        PRET_REGLEMENT_CE: 'PRC',
        REMB_PRET_BENEF: 'RPB',
        REMB_ANTICIPE_PRET: 'RAP',
        DON_CE_BENEF: 'DCB',
        FRAIS_DOSSIER: 'FRD',
        ANNULATION_FRAIS_DOSSIER: 'AFD',
        ABONDEMENT_EPARGNE: 'ABE',
        TRANSFERT_EPARGNE: 'TPM',
        PRODUIT_EXCEPTIONNEL: 'PRE',
        REMB_TROP_PERCU: 'RTP',
        REJET_ACOMPTE_CLIENT: 'RAC',
        ANNUL_IMPUT_ACOMPTE_CLIENT: 'AIA',
        ANNUL_JUSTIF_REMBOURSEMENT: 'AJR',
        SUPPRESSION_REGLEMENT: 'SR',
        DECAISSEMENT: 'DEC',
    },
    helpDeskInfo: {
        websiteUrl: 'http://sos.123ce.net',
        phoneNumber: '09 70 256 256'
    },
    mediaLibrariesWeekdaysList: [
        {code: 'LUN', label: 'lundi'},
        {code: 'MAR', label: 'mardi'},
        {code: 'MER', label: 'mercredi'},
        {code: 'JEU', label: 'jeudi'},
        {code: 'VEN', label: 'vendredi'},
        {code: 'SAM', label: 'samedi'},
        {code: 'DIM', label: 'dimanche'},
    ],
    mediaTypesList: [
        {code: applicationCodes.MDKAUCUN, label: 'Aucun'},
        {code: applicationCodes.MDKLIV, label: 'Livre'},
        {code: applicationCodes.MDKZIK, label: 'CD'},
        {code: applicationCodes.MDKVID, label: 'DVD'},
        {code: applicationCodes.MDKLOG, label: 'Logiciel'},
        {code: applicationCodes.MDKAUT, label: 'Autre'}
    ],
    movementsCodesType: {
        SUBACT: 'SUBACT',
        ATBBDG: 'ATBBDG',
        PTSACT: 'PTSACT',
        RAN: 'RAN',
        KAL: 'KAL',
        RV1PTS: 'RV1PTS',
        ATMSUB: 'ATMSUB',
        SPMSUB: 'SPMSUB',
        ATMPTS: 'ATMPTS',
        SPMPTS: 'SPMPTS',
        ATMQTA: 'ATMQTA',
        SPMQTA: 'SPMQTA',
    },
    beneficiariesType: {
        conjoint: 'CON',
        enfant: 'ENF',
        externe: 'EXT',
        od: 'OD'
    },
    rulesType: {
        acc: 'ACC',
        subv: 'SUB',
        lim: 'LIM',
        rac: 'RAC',
        enveloppe: 'ENV',
        quota: 'QUOTA',
        complementaire: 'COMP',
    },
    vouchersType :{
        CONJOINT : 'CONJ',
        ENFANT : 'ENF',
        EXTERNE : 'EXT',
        CRITERES_SOCIAUX : 'CRISOC',
        IBAN : 'IBAN',
        DIVERS : 'DIV'
    },
    fileFormatTypes : {
        XLSX : 'XLSX',
        PDF : 'PDF',
        XLS: 'XLS'
    },
    fileDimension : {
        logo :  '240px de large sur 80px de haut, jpg ou png 72dpi',
        headband: '1170px de large sur 100px de haut, jpg ou png 72dpi',
        background: '1920px de large sur 1200px de haut, jpg 72dpi'
    }
};
